export default [
  'ApplicationConfigData',
  class TermsController {
    constructor (applicationConfigData) {
      this.config = applicationConfigData.getConfig();
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/pages/legal/terms-of-service/terms-of-service.ctrl.js